import HttpClient from '../services/HttpClient';
import axios from 'axios';


const instancia = axios.create();
instancia.CancelToken = axios.CancelToken;
instancia.isCancel = axios.isCancel;


export const crearRating = async (rating)=>{
    try {
        const response = await instancia.post("/api/properties/crearating", rating);
        return response;
    } catch (error) {
        // Si hay error de conexión, `error.response` podría ser undefined
        return error.response || {
            status: 500,
            data: { message: "Network error" }
        };
    }
}